import type { DevEnv } from "../../../types/environment.ts";
import { awsRoleName } from "../aws/policy/shared.ts";

export const installTf = (context: DevEnv, locals: { vpcId: string }) => {
  const iamRole = awsRoleName(context, "iam-write");
  return `
module "aws_rds_vpc" {
  source  = "p0-security/p0-rds-vpc/aws"
  version = "0.1.3"

  aws_role_name = "${iamRole}"
  vpc_id        = "${locals.vpcId}"
}
`.trim();
};
